/* eslint-disable react/prop-types */
import React, { forwardRef, useState } from "react";
import i18n from "../../Helpers/i18n";
import { AlertTriangle } from "react-feather";
var TextInput = forwardRef(function (_a, ref) {
    var onFocus = _a.onFocus, label = _a.label, bindName = _a.bindName, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, error = _a.error, errorMessage = _a.errorMessage, _b = _a.type, type = _b === void 0 ? "text" : _b, placeholder = _a.placeholder, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.onlyNumbers, onlyNumbers = _d === void 0 ? false : _d, _e = _a.customStyle, customStyle = _e === void 0 ? "" : _e, _f = _a.onlyNumberWarning, onlyNumberWarning = _f === void 0 ? function () { return null; } : _f;
    var _g = useState(type), inputType = _g[0], setType = _g[1];
    var handleChange = function (e) {
        e.preventDefault();
        /**
         * Prevent non number values inside onlyNumbers inputs
         */
        if (onlyNumbers) {
            var numbersRegex = /^[0-9\b]+$/;
            if (e.target.value === "" ||
                numbersRegex.test(e.target.value)) {
                onChange(e);
            }
            else {
                onlyNumberWarning();
            }
            return;
        }
        onChange(e);
    };
    var htmlDecode = function (encodedString) {
        var fakeDoc = new DOMParser().parseFromString(encodedString, "text/html");
        return fakeDoc.documentElement.textContent;
    };
    var handleChangeType = function () {
        if (type !== "password") {
            return;
        }
        if (inputType === "password") {
            return setType("text");
        }
        return setType("password");
    };
    return (React.createElement("div", { className: "pottsalat-form__row ".concat(customStyle) },
        label && (React.createElement("label", { className: "pottsalat-form__label" }, label)),
        React.createElement("div", { className: "pottsalat-form__input-wrapper" },
            React.createElement("input", { className: "pottsalat-form__text-".concat(error ? "error" : "input"), type: inputType, name: bindName, onChange: handleChange, onFocus: onFocus, value: value, onBlur: onBlur, disabled: disabled, autoComplete: "off", placeholder: placeholder, ref: ref }),
            type === "password" && (React.createElement("span", { className: "pottsalat-form__password-show", onClick: handleChangeType }, inputType === "password" ? (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fas fa-eye gradient-right-text" }),
                React.createElement("span", null, i18n.t("form.password.show")))) : (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fas fa-eye-slash gradient-right-text" }),
                React.createElement("span", null, i18n.t("form.password.hide"))))))),
        error && (React.createElement("span", { className: "pottsalat-form__error-msg" },
            React.createElement(AlertTriangle, null),
            htmlDecode(errorMessage)))));
});
TextInput.displayName = "TextInput";
export default TextInput;
